import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import AdminLayout from '../../Componets/AdminLayout';
import axios from 'axios';
import DataTable from 'react-data-table-component';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-tooltip/dist/react-tooltip.css';
import { Tooltip } from 'react-tooltip';

export default function ExamSetting() {
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const location = useLocation();
  const { id, examname } = location.state || {};
  const [examDetails, setExamDetails] = useState({ name: '', subjects: [] });
  const [subjectList, setSubjectList] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [loadingtable, setLoadingtable] = useState(false);
  const [loadingbr, setLoadingbr] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const firstInputRef = useRef(null); // Reference to the first input
  const isInitialLoad = useRef(true); // Track first load

  // Function to fetch exam details and subject list
  const fetchExamDetails = async () => {
    try {
      setLoadingtable(true);
      const token = localStorage.getItem('token');
      const response = await axios.get(
        `${apiUrl}/api/exam/pages-setting/${id}`,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );

      const pageSettings = response.data;

      setExamDetails({
        name: `Exam ${id}`,
        subjects: pageSettings.map((setting) => ({
          subjectId: setting.subjectId,
          subjectName: setting.subjectName,
          removePage: setting.removePage || '',
          minimumPage: setting.minimumPage || '', // Initialize minimumPage
        })),
      });

      setSubjectList(
        pageSettings.map((setting) => ({
          id: setting.subjectId,
          name: setting.subjectName,
        }))
      );
      setLoadingtable(false);
    } catch (err) {
      setLoadingtable(false);
      console.error(err);
      toast.error(err.response?.data?.message);
      err.response?.status === 401 && navigate('/');
    }
  };

  // Fetch the exam details and subject list when the component mounts
  useEffect(() => {
    const role = localStorage.getItem('role');
    if (role !== 'ADMIN') {
      navigate('/');
    } else {
      fetchExamDetails();
    }
  }, [apiUrl, id, navigate]);

  const getSubjectNameById = (subjectId) => {
    const subject = subjectList.find((sub) => sub.id === subjectId);
    return subject ? subject.name : 'Unknown';
  };

  const filteredSubjects = examDetails.subjects.filter((subject) =>
    getSubjectNameById(subject.subjectId)
      .toLowerCase()
      .includes(searchQuery.toLowerCase())
  );

  const handleInputChange = (subjectId, field, value) => {
    setExamDetails((prev) => ({
      ...prev,
      subjects: prev.subjects.map((subject) =>
        subject.subjectId === subjectId
          ? { ...subject, [field]: value }
          : subject
      ),
    }));
  };

  const handleSave = () => {
    setLoadingbr(true);
    const token = localStorage.getItem('token');
    const subjectRemovePages = examDetails.subjects
      .filter((subject) => subject.removePage || subject.minimumPage) // Only include subjects with values
      .map((subject) => ({
        subjectId: subject.subjectId,
        removePage: parseInt(subject.removePage) || null,
        minimumPage: parseInt(subject.minimumPage) || null, // Ensure minimumPage is included
      }));

    const data = {
      examId: id,
      subjectRemovePages,
    };

    const config = {
      method: 'post',
      url: `${apiUrl}/api/exam/pages-setting`,
      headers: {
        Authorization: ` ${token}`,
        'Content-Type': 'application/json',
      },
      data: JSON.stringify(data),
    };

    axios
      .request(config)
      .then((response) => {
        setLoadingbr(false);
        fetchExamDetails(); // Refetch to update the table
        toast.success('Saved successfully');
      })
      .catch((error) => {
        setLoadingbr(false);
        toast.error(error.response?.data?.message || 'Error saving data');
        console.error(error);
      });
  };

  const columns = [
    {
      name: 'No',
      selector: (row, index) => {
        // Calculate serial number based on current page and rows per page
        return (currentPage - 1) * rowsPerPage + index + 1;
      },
      width: '50px',
      center: 'true',
    },
    {
      name: 'Subject Name',
      selector: (row) => getSubjectNameById(row.subjectId),
    },
    {
      name: 'Page skip',
      width: '133px',
      center: 'true',
      cell: (row, index) => (
        <input
          type="text"
          className="form-control"
          placeholder="Add Count"
          value={row.removePage || ''}
          ref={index === 0 ? firstInputRef : null} // Assign ref to the first input box
          onChange={(e) =>
            handleInputChange(row.subjectId, 'removePage', e.target.value)
          }
        />
      ),
    },
    {
      name: 'Minimum page',
      width: '133px',
      center: 'true',
      cell: (row) => (
        <input
          type="text"
          className="form-control"
          placeholder="Add Count"
          value={row.minimumPage || ''}
          onChange={(e) =>
            handleInputChange(row.subjectId, 'minimumPage', e.target.value)
          }
        />
      ),
    },
  ];
  useEffect(() => {
    if (
      isInitialLoad.current &&
      firstInputRef.current &&
      examDetails.subjects.length > 0
    ) {
      firstInputRef.current.focus(); // Focus on the first input field when data loads
      isInitialLoad.current = false; // Prevent future calls
    }
  }, [examDetails.subjects]); // Runs only when subjects are fetched

  return (
    <AdminLayout ac4="active">
      <main id="main" className="main">
        <div className="pagetitle mb-4">
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/AdminHome">Dashboard</Link>
              </li>
              <li className="breadcrumb-item">
                <Link to="/ListExam">View Exam</Link>
              </li>
              <li className="breadcrumb-item active">
                Sheet Setting ({examname})
              </li>
            </ol>
          </nav>
        </div>
        <hr className="mb-0" />
        <section className="section col-lg-12">
          <div className="datatable-top">
            <div className="datatable-search">
              <input
                className="form-control"
                type="text"
                name="totalMarks"
                placeholder="Search"
                title="Search within table"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
          </div>
          <DataTable
            columns={columns}
            data={filteredSubjects}
            pagination
            progressPending={loadingtable}
            className="custom-table"
            paginationPerPage={rowsPerPage} // Set rows per page
            paginationTotalRows={filteredSubjects.length} // Total number of records
            paginationDefaultPage={currentPage} // Default starting page
            onChangePage={(page) => setCurrentPage(page)} // Update current page
            onChangeRowsPerPage={(newPerPage) => setRowsPerPage(newPerPage)} // Update rows per page
          />
          <div className="d-flex justify-content-end mt-3">
            <button
              onClick={() => navigate('/ListExam')}
              className="btn btn-primary"
            >
              <i className="bi bi-arrow-bar-left"></i> Back
            </button>
            <button
              onClick={handleSave}
              className="btn btn-primary ms-2 px-4"
              disabled={loadingbr}
            >
              {loadingbr ? 'Saving...' : ' Save '}
            </button>
          </div>
          <ToastContainer position="top-center" style={{ width: 'auto' }} />
        </section>
      </main>
    </AdminLayout>
  );
}
